import React from 'react'
import Navbar from '../components/Navbar'
import HeroImg from '../components/HeroImg'
import Footer from '../components/Footer'
import AboutContent from '../components/AboutContent'
import Form from '../components/Form'
import Service from '../components/Service'
import Customers from './Customers'
import ScrollToTop from '../components/ScrollToTop'

const Home = () => {

  return (
    <div className='home-section' id="home-section">
      <Navbar />
      <HeroImg />
      <AboutContent />
      <Service />
      <Form />
      <Customers />
      <ScrollToTop />     
      <Footer />
    </div>
  )
}

export default Home